import api from '.';
import { buildQueryWithParams, makeListTags } from '../../Utils/api';
import {setUser} from "../reducers/authSlice.js";

const tagType = 'usersList';

const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    //possible querry params are page,itemsPerPage,filter,orgId

    createUser: builder.mutation({
      query: (data) => ({ url: `/users`, method: 'POST', body: data }),
      transformResponse:(res)=>{
        return res
      }
    }),

    getUsers: builder.query({
      query: ({filter, mine}) => ({
        url: buildQueryWithParams('/users'),
        params: {
          filter,
          ...(mine && { organization: 'mine' }),
        },
      }),
      transformResponse: (res) => res,
      providesTags: makeListTags(tagType),
    }),
    getOrganizationUsers: builder.query({
      query: ({id,filter}) => ({
        url: `organizations/${id}/users`,
        method: 'GET',
        params: {filter}

      }),
      transformResponse: (res) => {
        return res;
      },

      providesTags: makeListTags(tagType)
    }),
    inviteUser: builder.mutation({
      query: (userInfo) => ({
        url: `/invitations`,
        method: 'POST',
        body: userInfo
      }),
      invalidatesTags: [tagType, 'organization']
    }),

    updateUser: builder.mutation({
      //TODO OP, also send the items per page and page nr and filters

      query: (params) => ({ url: `/users`, method: 'POST', body: params.userInfo }),
      async onQueryStarted({ ...params }, { dispatch, queryFulfilled }) {
        try {
          const { userInfo, cacheParams } = params;
          const { data: updatedUser } = await queryFulfilled;
          const results = dispatch(
            api.util.updateQueryData('requestUsersList', cacheParams, (requestedUserList) => {
              const index = requestedUserList.list.findIndex((item) => {
                return item.id === userInfo.id || item._id === userInfo.id;
              });
              requestedUserList.list[index] = updatedUser;
            })
          );
          return results
        } catch (error) {
          console.error('error updating user', error);
        }
      },

      //pesimistic updates don't work when invalidatin tags
      invalidatesTags: ['organization']
    }),

    updateUserData: builder.mutation({
      query: (params) => ({
        url: `/users/${params.id}`, // Include the user ID in the URL
        method: 'PATCH',
        body:  params.userInfo
      }),
    }),

    updateOrganizationAdminUserData: builder.mutation({
      query: (params) => ({
        url: `/organizations/${params.orgId}/users?where=${JSON.stringify(params.where)}`,
        method: 'PATCH',
        body: params.userInfo
      }),
    }),

    getChargingUserAccess: builder.query({
      query: (params) => ({
        url:`/charge-points/${params.chargePointId}/charge-point-connectors/${params.chargePointConnectorId}/access`
      }),

    }),

    updateUserParentOrg: builder.mutation({
      query: (params) => ({
        url: `/users/${params.id}`, // Include the user ID in the URL
        method: 'PATCH',
        body:  params.parentOrg
      }),
      
    }),
  })
});

export default usersApi;
export const {
  useCreateUserMutation,
  useGetUsersQuery,
  useUpdateUserDataMutation,
  useUpdateUserMutation,
  useInviteUserMutation,
  useGetChargingUserAccessQuery,
  useUpdateUserParentOrgMutation,
  useUpdateOrganizationAdminUserDataMutation,
  useGetOrganizationUsersQuery
} = usersApi;
